<div class="adtabcontent">
<app-column-header [headerData]="headerData" (topbtnaction)="menuBack()"></app-column-header>
<!-- <div class="row">
    <div class="col-2-of-2">     
      <button type="button" class="btn btn-danger" *ngIf="menuParentId != 0" (click)="menuBack()">Back</button>
    </div>
  </div> -->
  <div class="admcontent rowlist">
<ul class="admitemlist fourcolum">
  <li *ngFor="let data1 of menuChildListdata">
      <span>
          <svg>
              <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_menu_icon"></use>
          </svg>
      </span>
      <a href="" class="cursrponts">
          {{data1.gstibo_menu_name}}
      </a>
      <div  [ngClass]="(data1.gstibo_menu_name =='Settings' ? 'actions disable-click':'actions')">
          <button class="edit" (click)="editMenu(data1.gstibo_menu_id)">
              <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
              </svg>
          </button>
          <button class="delete" (click)="deleteMenu(data1.gstibo_menu_id)">
              <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
              </svg>
          </button>
         
      </div>
    <!-- <figure class="back-blue">
      <svg class="icon">
        <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_menu_icon"></use>
      </svg>
    </figure> -->
    <!-- <figcaption>
      {{data1.gstibo_menu_name}}</figcaption> -->
    <!-- <div class="editApp-pages" [ngClass]="(data1.gstibo_menu_name =='Settings' ? 'disable-click':'')">
      <a (click)="editMenu(data1.gstibo_menu_id)">Edit</a>
      <a (click)="deleteMenu(data1.gstibo_menu_id)">Delete</a>
    </div> -->
  </li>
</ul>
</div>

<!-- <div class="iconBlock">

       

    <div class="appNames" *ngFor="let data of menuChildListdata">
      <h4 > {{data.gstibo_menu_name}}</h4>
      <p>
        <a
          (click)="editMenu(data.gstibo_menu_id)">Edit</a>
        |
        <a (click)="deleteMenu(data.gstibo_menu_id)">Delete</a>
      </p>
    
    </div>
  
  </div> -->
  </div>